import { ControllerFlowAPI, IUser, ReportError } from '@wix/yoshi-flow-editor';
import { BookingsDataCapsule } from '@wix/bookings-data-capsule';
import { FormApi } from '../../api/FormApi';
import { TFunction } from '../../types/types';
import { FormBiLogger } from '../bi/biLoggerFactory';
import { IFlowApiAdapter } from '../flow-api-adapter/types';

export type FormContext = {
  t: TFunction;
  settings: ControllerFlowAPI['settings'];
  experiments: ControllerFlowAPI['experiments'];
  wixSdkAdapter: IFlowApiAdapter;
  bookingsDataCapsule: BookingsDataCapsule;
  formApi: FormApi;
  biLogger?: FormBiLogger;
  reportError: ReportError;
  user: IUser;
};

export const createFormContext = ({
  t,
  flowApi,
  wixSdkAdapter,
  bookingsDataCapsule,
  formApi,
  biLogger,
  reportError,
  user,
}: {
  t: TFunction;
  flowApi: ControllerFlowAPI;
  wixSdkAdapter: IFlowApiAdapter;
  bookingsDataCapsule: BookingsDataCapsule;
  formApi: FormApi;
  biLogger?: FormBiLogger;
  reportError: ReportError;
  user: IUser;
}): FormContext => {
  return {
    t,
    settings: flowApi.settings,
    experiments: flowApi.experiments,
    wixSdkAdapter,
    bookingsDataCapsule,
    formApi,
    biLogger,
    reportError,
    user,
  };
};
